<ion-app>
  <bones-side-menu [actions]="actions" contentId="menu1" type="push"></bones-side-menu>
  <ion-router-outlet id="menu1" main></ion-router-outlet>
</ion-app>
